import T1G from "assets/images/game/crash-game/crash-game_T1G.png";
import { SubGameType } from "types/game";

export const listGameCrashGame: SubGameType[] = [
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "T1G",
    type: "BG",
    featured: "NO",
    new_arrive: "NO",
    picture: T1G,
  },
];
